module.exports = __webpack_public_path__ + "assets/img/fireElevator-one.051ac860.png";